import React from "react";
import { useParams, useHistory } from "react-router-dom";

// Config
import { getRoute, urls } from "../../config/routes";

// Components
import PhysicalDamageDetailPanel from "../../components/PhysicalDamageDetailPanel";
import SectionWrapper from "../../components/SectionWrapper";

const PhysicalDamageDetailPage = () => {
  const { caseId, physicalDamageId } = useParams();
  const history = useHistory();

  React.useEffect(() => {
    if (!physicalDamageId || physicalDamageId === "undefined")
      history.push(getRoute(urls.caseDetail, { caseId }));
  }, [history, physicalDamageId]);

  return (
    <SectionWrapper>
      <PhysicalDamageDetailPanel
        caseId={caseId}
        physicalDamageId={physicalDamageId}
      />
    </SectionWrapper>
  );
};

export default PhysicalDamageDetailPage;
